/*
 Sets up jQuery's XHR support to automatically send along a CSRF token with each XHR.
 */

define([],
    function() {
        // this object also acts as the source of priority/order of filter rendering
        let filterNameMapping = {
            sentiment: {
                plural: "Scores",
                singular: "Score",
                table_key: "score",
            },
            ratings: {
                plural: "Ratings",
                singular: "Rating",
                table_key: "rating",
                type: "int",
            },
            comments: {
                plural: "Comments",
                singular: "Comment",
                table_key: "comments",
            },
            comment: {
                plural: "Comments",
                singular: "Comment",
                table_key: "comment",
            },
            campaigns: {
                plural: "Campaigns",
                singular: "Campaign",
                table_key: "campaign",
            },
            contact_types: {
                plural: "Contact Types",
                singular: "Contact Type",
                table_key: "contact_types",
            },
            titles: {
                plural: "Contact Titles",
                singular: "Contact Title",
                table_key: "contact_title",
            },
            marketing_groups: {
                plural: "Marketing Groups",
                singular: "Marketing Group",
                table_key: "marketing_groups",
            },
            companies: {
                plural: "Companies",
                singular: "Company",
                table_key: "company",
            },
            agents: {
                plural: "Agents",
                singular: "Agent",
                table_key: "agent",
            },
            company_types: {
                plural: "Company Types",
                singular: "Company Type",
                table_key: "company_types",
            },
            company_statuses: {
                plural: "Company Statuses",
                singular: "Company Status",
                table_key: "company_status",
            },
            locations: {
                plural: "Locations",
                singular: "Location",
                table_key: "location",
            },
            is_primary: {
                plural: "Primary Contacts",
                singular: "Primary Contact",
                table_key: "is_primary",
            },
            is_billing: {
                plural: "Billing Contacts",
                singular: "Billing Contact",
                table_key: "is_billing",
            },
            groups: {
                plural: "Groups",
                singular: "Group",
                table_key: "groups",
                tooltip: "<strong>Group</strong> is a field in the Corporate Structure of ConnectWise PSA. It can be renamed, for example, to <strong>Department</strong> or <strong>Business Unit</strong>, but <strong>Group</strong> is the original title."
            },
            segments: {
                plural: `${globals.term['segment'] ? globals.term['segment'].charAt(0).toUpperCase() + globals.term['segment'].slice(1) : 'Segment'}s`,
                singular: `${globals.term['segment'] ? globals.term['segment'].charAt(0).toUpperCase() + globals.term['segment'].slice(1) : 'Segment'}`,
                table_key: "segment",
            },
            tags: {
                plural: "Tags",
                singular: "Tag",
                table_key: "tags",
            },
            statuses: {
                plural: "Review Statuses",
                singular: "Review Status",
                table_key: "status",
            },
            markets: {
                plural: "Markets",
                singular: "Market",
                table_key: "market",
            },
            territories: {
                plural: "Territories",
                singular: "Territory",
                table_key: "territory",
            },
            agreement_types: {
                plural: "Agreement Types",
                singular: "Agreement Type",
                table_key: "agreement_type",
            },
            classifications: {
                plural: "Classifications",
                singular: "Classification",
                table_key: "classification",
            },
            primaries: {
                plural: "Types",
                singular: "Primary Contact",
                table_key: "primary",
            },
            full_name: {
                plural: "Contact Names",
                singular: "Contact Name",
                table_key: "full_name",
            },
            contacts: {
                plural: "Contacts",
                singular: "Contact",
            },
            triggers: {
                plural: "Survey Periods",
                singular: "Survey Period",
            },
            managers: {
                plural: "Project Managers",
                singular: "Project Manager",
            },
            members: {
                plural: "Team Members",
                singular: "Team Member",
            },
            projects: {
                plural: "Projects",
                singular: "Project",
            },
        }

        let staticFilterData = {
            "csat-reviews": {
                ratings: {
                    values: [
                        {id: "1", name: '<img src="/static/img/sentiment_positive.svg" height="16" width="16">&nbsp; Positive'},
                        {id: "0", name: '<img src="/static/img/sentiment_neutral.svg" height="16" width="16">&nbsp; Neutral'},
                        {id: "-1", name: '<img src="/static/img/sentiment_negative.svg" height="16" width="16">&nbsp; Negative'}
                    ],
                    dataType: "int",
                },
                comments: {
                    values: [
                        {id: 'withCommentsOnly', name: "With comments only" },
                        {id: 'withoutCommentsOnly', name: "Without comments only"},
                        {id: 'withMarketingPermissionOnly', name: "With marketing permission"},
                        {id: 'withWidgetPublishedOnly', name: "Published on the Website Widget"}
                    ],  
                    variant: "radio",
                    default: "0",
                },
                statuses: {
                    values: [
                        {id: 'open', name: "Open"},
                        {id: 'done', name: "Done"},
                    ],
                }
            },
            "csat-analytics": {
                comments: {
                    values: [
                        {id: 'withCommentsOnly', name: "With comments only" },
                        {id: 'withoutCommentsOnly', name: "Without comments only"},
                        {id: 'withMarketingPermissionOnly', name: "With marketing permission"},
                        {id: 'withWidgetPublishedOnly', name: "Published on the Website Widget"}
                    ],  
                    variant: "radio",
                    default: "0",
                },
            },
            "nps-responses": {
                sentiment: {
                    values: [
                        {id: "1", name: "Promoters"},
                        {id: "0", name: "Passives"},
                        {id: "-1", name: "Detractors"}
                    ],
                },
                comment: {
                    values: [
                        {id: '1', name: "With comments only" },
                        {id: '2', name: "Without comments only"},
                        {id: '3', name: "With marketing permission"},
                        {id: '4', name: "Published on the Website Widget"}
                    ],  
                    variant: "radio",
                    default: "0",
                },
            },
            "project-survey": {
                comments: {
                    values: [
                        {id: '1', name: "With comments only" },
                        {id: '2', name: "Without comments only"},
                        {id: '3', name: "With marketing permission"},
                        {id: '4', name: "Published on the Website Widget"}
                    ],  
                    variant: "radio",
                    default: 0,
                    dataType: "int",
                },
            },
        }

        let defaultFilterParams = {
            "csat-reviews": {
                comments: "0",
                ratings: [],
                statuses: [],
            },
            "csat-analytics": {
                comments: "0",
            },
            "nps-responses": {
                comment: "0",
                sentiment: [],
                is_billing: [],
                is_primary: [],
            },
            "project-survey": {
                q: "",
                limit: 10,
                page: "1",
                triggers: [],      
                contacts: [],
                companies: [],
                projects: [],
                members: [],
                managers:[],
                comments: 0,
                sort: {
                    field: "date",
                    value: null,
                    direction: "desc"        
                }
            }
        }

        return {
            'filterNameMapping': filterNameMapping,
            'staticFilterData': staticFilterData,
            'defaultFilterParams': defaultFilterParams,
        };
    }
);
